import { useSelector } from 'react-redux';
import {
    getMarketplaceExoticTypes,
    getPetHairLengths,
    getPetSizes
} from 'reducers/marketplace/MarketplaceSelectors';
import {
    getPetBreeds,
    getPetGenders,
    getPetHairColors,
    getPetTypesOptions
} from 'reducers/masterData/MasterDataSelectors';
import { RootState } from 'store';
import { PetBreed, PetTypeId, PetTypeIds } from 'types/Pet';

export const usePetFormData = (petType?: PetTypeId) => {
    const types = useSelector(getPetTypesOptions);

    const genders = useSelector(getPetGenders);

    const sizes = useSelector((state: RootState) => (petType ? getPetSizes(state, petType) : []));

    const hairLengths = useSelector((state: RootState) =>
        petType ? getPetHairLengths(state, petType) : []
    );

    const masterDataBreeds = useSelector(state => (petType ? getPetBreeds(state, petType) : []));
    const exoticTypes = useSelector(getMarketplaceExoticTypes);

    const breeds: Array<PetBreed> = petType === PetTypeIds.EXOTIC ? exoticTypes : masterDataBreeds;

    const hairColors = useSelector(state => (petType ? getPetHairColors(state, petType) : []));

    return {
        types,
        sizes,
        breeds,
        genders,
        hairColors,
        hairLengths
    };
};
